export default __webpack_public_path__ + "static/media/grid_active.d8e345bd.svg";